import { modal, button } from '../common/Modal.js';
import { summarizeRaces, isFinished, raceYear, getPersonalBests } from '../../../../functions/shared/raceMetrics.mjs';
import { projectPublicResume } from '../../../../functions/shared/publicResume.mjs';
export function showYearRecap(resume) {
  const dialog = modal('Share a year of running');
  const note = document.createElement('p'); note.textContent = 'This recap uses your public profile selections, even before publishing. Review the image before downloading.';
  const year = document.createElement('select'); year.className = 'editor-input'; year.setAttribute('aria-label', 'Recap year');
  const data = projectPublicResume(resume);
  const years = [...new Set(data.races.map(raceYear).filter(y => y !== null))].sort((a,b) => b-a);
  for (const y of years) year.add(new Option(String(y), String(y)));
  const canvas = document.createElement('canvas'); canvas.width = 1080; canvas.height = 1350; canvas.style.cssText = 'width:100%;height:auto;border-radius:16px';
  const draw = () => {
    const races = data.races.filter(r => raceYear(r) === Number(year.value));
    const stats = summarizeRaces(races); const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#0b1020'; ctx.fillRect(0,0,1080,1350);
    const text = (s,x,y,size,color='#ffffff') => { ctx.fillStyle=color; ctx.font=`${size >= 50 ? 'bold ' : ''}${size}px sans-serif`; ctx.fillText(s,x,y,920); };
    text('MY YEAR IN RUNNING',80,110,28,'#4fd7df'); text(year.value || 'No dated races',80,275,130);
    text(data.name || 'Runner',80,375,54); text('RUNNING RESUME',80,425,22,'#a4b4cc');
    const finishes = races.filter(isFinished).length;
    canvas.setAttribute('role', 'img');
    canvas.setAttribute('aria-label', `${year.value}: ${finishes} finishes, ${Math.round(stats.totalDistance)} kilometres, ${Math.round(stats.totalElevation)} metres climbed`);
    text(`${finishes} ${finishes === 1 ? 'finish' : 'finishes'}`,80,570,70);
    text(`${Math.round(stats.totalDistance).toLocaleString()} km finished`,80,670,60);
    text(`${Math.round(stats.totalElevation).toLocaleString()} m climbed`,80,755,48);
    text('ROAD PERSONAL BESTS THIS YEAR',80,865,22,'#4fd7df');
    const bests = [...getPersonalBests(races)].slice(0,3);
    if (!bests.length) text('Every finish is part of the story.',80,930,30,'#a4b4cc');
    bests.forEach(([label,r],i) => text(`${label}  ·  ${r.time}`,80,930+i*65,36));
    text('therunninggenie.com',80,1210,30,'#4fd7df');
    if (resume.isPublished) text(`therunninggenie.com/r/${resume.id}`,80,1270,22,'#a4b4cc');
  };
  year.addEventListener('change', draw); draw();
  const download = button('Download recap PNG', () => { const a=document.createElement('a'); a.download=`running-recap-${year.value}.png`; a.href=canvas.toDataURL('image/png'); a.click(); }); download.disabled = !years.length;
  dialog.append(note,year,download,canvas);
}
